<template lang='pug'>
v-card(width='480' class='unsupported-format-dialog')
    div.pt-10.pb-6
        v-card-title.d-flex.align-center.flex-column.justify-center.pa-0
            v-img(:src='unsupportedIcon' width='70' height='70' contain)
        v-card-text.pt-4.px-10.text-center
            span(
                class='dialog-message'
                style='font-family: "Noto Sans TC"; font-size: 16px; font-weight: 500; color: #535353; letter-spacing: 0.5px; line-height: 150%;'
            ) {{ message }}
    v-card-actions.px-6.py-4.justify-end(style='background-color: #F8F9FA; border-top: 1px solid #E8E8E8;')
        v-btn(
            @click='onConfirm'
            width='100px'
            height='40'
            color='#14C6DE'
            style='border-radius: 4px;'
            :ripple='false'
            depressed
        )
            span(style="font-family: 'Segoe UI'; font-weight: 600; font-size: 16px; letter-spacing: 0.5px; color: #FFFFFF;") OK
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    props: {
        successCount: { type: Number, default: 0 },
        failCount: { type: Number, default: 0 },
    },
    data() {
        return {
            unsupportedIcon: require('@/assets/images/unsupported_file_format.svg'),
        };
    },
    computed: {
        message() {
            return this.$t('DOCUMENT_AGENT.UNSUPPORTED_FILES_SUMMARY', {
                successCount: this.successCount,
                failCount: this.failCount,
            });
        },
    },
    methods: {
        onConfirm() {
            this.$emit('confirm');
        },
    },
});
</script>

<style scoped lang="css">
.unsupported-format-dialog {
    border-radius: 8px !important;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2) !important;
}
.dialog-message {
    line-height: 1.6;
    white-space: pre-line;
}
</style>
